import { getSupabaseClient } from "../../providers/supabase/supabase";

export type TranscribeChunkResult = {
  /** El texto completo actualizado de la llamada, o null si el fragmento no se transcribió. */
  text: string | null;
  /** 403 (sin consentimiento/función desactivada) o 429 (cupo): no vale la pena seguir
   * mandando fragmentos, hay que detener la captura. */
  fatal: boolean;
  /** Mensaje del servidor para mostrar a Ian (null cuando todo salió bien). */
  message: string | null;
};

/** Manda un fragmento de audio a transcribir (Bloque C2, paso 4). El fragmento se descarta
 * en el navegador en cuanto esta llamada termina (quien la usa no debe guardarlo). */
export const sendAudioChunk = async (
  consentId: number,
  blob: Blob,
  durationSeconds: number,
): Promise<TranscribeChunkResult> => {
  const form = new FormData();
  form.append("consent_id", String(consentId));
  form.append(
    "duration_seconds",
    String(Math.max(1, Math.round(durationSeconds))),
  );
  form.append("audio", blob, "chunk.webm");

  const { data, error, response } = await getSupabaseClient().functions.invoke<{
    text?: string;
  }>("copilot_transcribe", { body: form });

  if (error) {
    const status = response?.status;
    const body = response
      ? await response.json().catch(() => null as { message?: string } | null)
      : null;
    return {
      text: null,
      fatal: status === 403 || status === 429,
      message: body?.message ?? "No se pudo transcribir el fragmento.",
    };
  }
  return { text: data?.text ?? null, fatal: false, message: null };
};
